// A PIECE task closed short by a declared shortage stays COMPLETED and has its own
// `expected_quantity` rewritten down to what was picked, so the task counter reads 1/1 and hides
// the shortage. The per-product breakdown does not: `order_summary` derives it from the order's
// stock units, and the pieces that were not found are still RESERVED at the task's location, so
// they keep showing up as expected-but-not-picked. Always total from the breakdown.
export const totalsFromProducts = (products) =>
    (products || []).reduce(
        (acc, p) => ({ expected: acc.expected + (p.expected || 0), picked: acc.picked + (p.picked || 0) }),
        { expected: 0, picked: 0 }
    )

// Prefer the breakdown while it has something — that is what exposes a short close — and fall
// back to the task's own counters once it is empty. The breakdown only counts RESERVED and PICKED
// units, so packing empties it as it moves them to PACKED, and a packed order would read 0/0.
export const totalsForTask = (task, products) =>
    (products || []).length > 0
        ? totalsFromProducts(products)
        : { expected: task?.expected_quantity || 0, picked: task?.picked_quantity || 0 }

export const isTaskClosedShort = ({ task, expected, picked }) =>
    task?.status === 'COMPLETED' && picked < expected
